import React from "react";
import { Link } from "react-router-dom";

export function SectionEyebrow({ children }) {
    return (
        <div className="flex items-center gap-3 mb-3">
            <span className="lnl-gold-rule" />
            <span className="lnl-eyebrow">{children}</span>
        </div>
    );
}

export function SectionHeading({ eyebrow, title, description, align = "left" }) {
    return (
        <div className={align === "center" ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
            {eyebrow && <SectionEyebrow>{eyebrow}</SectionEyebrow>}
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-lnl-charcoal leading-tight">{title}</h2>
            {description && <p className="mt-3 text-lnl-gray text-base leading-relaxed">{description}</p>}
        </div>
    );
}

export function DraftNotice({ children, tone = "info" }) {
    const tones = {
        info: "bg-lnl-green-bg text-lnl-green-deep border-lnl-green/20",
        warn: "bg-amber-50 text-amber-900 border-amber-200",
    };
    return (
        <div className={`text-xs rounded-md border px-3 py-2 ${tones[tone]}`}>{children}</div>
    );
}

export function PageHero({ eyebrow, title, description, breadcrumbs = [], cta }) {
    return (
        <section className="bg-lnl-off-white border-b border-lnl-border">
            <div className="lnl-container py-12 md:py-16">
                {breadcrumbs.length > 0 && (
                    <nav aria-label="Breadcrumb" className="text-xs text-lnl-gray mb-4">
                        {breadcrumbs.map((b, i) => (
                            <span key={i}>
                                {b.to ? <Link to={b.to} className="hover:text-lnl-green">{b.label}</Link> : <span>{b.label}</span>}
                                {i < breadcrumbs.length - 1 && <span className="mx-1.5 text-lnl-border">/</span>}
                            </span>
                        ))}
                    </nav>
                )}
                {eyebrow && <SectionEyebrow>{eyebrow}</SectionEyebrow>}
                <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-lnl-charcoal leading-tight max-w-3xl">{title}</h1>
                {description && <p className="mt-4 text-base sm:text-lg text-lnl-gray max-w-3xl leading-relaxed">{description}</p>}
                {cta}
            </div>
        </section>
    );
}
